
import BaseViewModel from 'mesitis/baseViewModel';
import 'mesitis/account/authComponent';
import { mountBasePage } from '../shared';


const loginRoot = document.getElementById('login-page');
const vm = new BaseViewModel() as any;
vm.returnUrl = loginRoot?.dataset.returnUrl || '';
vm.loginMode = 1;

mountBasePage(vm);
